import PropTypes from 'prop-types'

import classNames from 'classnames'
import Link from './Link'
import FacebookLogo from 'public/assets/images/icons/social/facebook.svg?react'
import InstagramLogo from 'public/assets/images/icons/social/instagram.svg?react'
import LinkedinLogo from 'public/assets/images/icons/social/linkedin.svg?react'
import TiktokLogo from 'public/assets/images/icons/social/tiktok.svg?react'
import XLogo from 'public/assets/images/icons/social/x.svg?react'
import YoutubeLogo from 'public/assets/images/icons/social/youtube.svg?react'
import styles from './styles/SocialIcon.css'

const SOCIAL = {
  x: {
    href: 'https://x.com/scite',
    Logo: XLogo
  },
  linkedin: {
    href: 'https://www.linkedin.com/company/sciteai/',
    Logo: LinkedinLogo
  },
  facebook: {
    href: 'https://facebook.com/sciteai',
    Logo: FacebookLogo
  },
  instagram: {
    href: 'https://www.instagram.com/scite.ai/',
    Logo: InstagramLogo
  },
  youtube: {
    href: 'https://www.youtube.com/channel/UCso9-KdHZ6vfbYgM59zp9EA',
    Logo: YoutubeLogo
  },
  tiktok: {
    href: 'https://www.tiktok.com/@scite.ai',
    Logo: TiktokLogo
  }
}

function SocialIcon({ type, href, className, ...rest }) {
  const { Logo } = SOCIAL[type]
  return (
    <Link
      className={classNames(styles.socialIcon, className)}
      href={href || SOCIAL[type].href}
      target='_blank'
      rel='noopener noreferrer'
      {...rest}
      aria-label={SOCIAL[type].href + ' (opens in a new tab)'}
    >
      <Logo aria-hidden='true' focusable='false' />
    </Link>
  )
}

SocialIcon.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  type: PropTypes.oneOf(['facebook', 'x', 'linkedin', 'instagram', 'youtube', 'tiktok'])
}
export default SocialIcon
